import { createContext, useContext } from 'react';
import { type FormView } from '../ui/form/types';

export const FormViewContext = createContext<FormView | undefined>(undefined);

export function useFieldView(fieldId: string) {
  const context = useFormView();
  const fieldView = context.fields.find((field) => field.id === fieldId);
  return fieldView;
}

export function useFormView() {
  const context = useContext(FormViewContext);
  if (context === undefined) {
    throw new Error('useFormView must be used within a FormViewProvider');
  }

  return context;
}
